module.exports = __webpack_public_path__ + "static/36-40c6da4c1e24d8b75adf89f9b07453d2.png";